import classNames from 'clsx';
import * as React from 'react';
import { formatClassNames } from '@wix/editor-elements-common-utils';

import semanticClassNames from '../../../../WIP_SearchBox.semanticClassNames';
import SearchSymbolSvg from '../../../assets/SearchSymbol.svg';
import style from './SearchSymbol.scss';

export const SearchSymbol: React.FC = () => {
  return (
    <div
      className={classNames(
        style.root,
        formatClassNames(semanticClassNames.icon),
      )}
    >
      <SearchSymbolSvg />
    </div>
  );
};
